<template>
  <general-layout v-show="'edit-account' === visibleModal" @close="modalClose()">
    <h4 class="modal-title" slot="header">{{ $t('account.editModal.header') }}</h4>

    <form slot="body">
      <p class="help-block">{{ $t('account.editModal.helpBlock') }}</p>
      <div class="form-group">
        <label>{{ $t('account.attributes.name') }}</label>
        <input class="form-control"
               :placeholder="$t('account.attributes.name')"
               :value="activeAccount.name"
               @change="setEmailServiceName">
      </div>

      <div class="form-group">
        <label>{{ $t('account.attributes.type') }}</label>
        <select class="form-control" :value="activeAccount.type" @change="setEmailService">
          <option value="">{{ $t('account.editModal.select') }}</option>
          <option value="getresponse">{{ $t('account.types.getResponse') }}</option>
          <option value="activecampaign">{{ $t('account.types.activeCampaign') }}</option>
          <option value="aweber">{{ $t('account.types.aweber') }}</option>
          <option value="egoi">{{ $t('account.types.eGoi') }}</option>
          <option value="mailchimp">{{ $t('account.types.mailChimp') }}</option>
          <option value="rdstation">{{ $t('account.types.rdStation') }}</option>
          <option value="convertkit">{{ $t('account.types.convertKit') }}</option>
        </select>
      </div>

      <active-campaign v-show="emailServiceType === 'activecampaign'"></active-campaign>
      <aweber v-show="emailServiceType === 'aweber'"></aweber>
      <e-goi v-show="emailServiceType === 'egoi'"></e-goi>
      <get-response v-show="emailServiceType === 'getresponse'"></get-response>
      <mailchimp v-show="emailServiceType === 'mailchimp'"></mailchimp>
      <rd-station v-show="emailServiceType === 'rdstation'"></rd-station>
      <convert-kit v-show="emailServiceType === 'convertkit'"></convert-kit>

    </form>

    <div class="row" slot="footer">
      <div class="col-md-12">
        <div class="form-group">
          <button type="button"
                  class="btn btn-success pull-right"
                  @click="saveAccount">
            {{ $t('account.editModal.save') }}
          </button>
        </div>
      </div>
    </div>
  </general-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import generalLayout from '../../../shared/components/modal/GeneralLayout';
import activeCampaign from './mailServices/ActiveCampaign';
import aweber from './mailServices/Aweber';
import eGoi from './mailServices/EGoi';
import getResponse from './mailServices/GetResponse';
import mailchimp from './mailServices/Mailchimp';
import rdStation from './mailServices/RdStation';
import convertKit from './mailServices/ConvertKit';

export default {
  components: {
    generalLayout,
    activeCampaign,
    aweber,
    eGoi,
    getResponse,
    mailchimp,
    rdStation,
    convertKit,
  },
  methods: {
    setEmailServiceName(event) {
      const value = event.target.value;
      this.setName(value);
    },
    setEmailService(event) {
      const value = event.target.value;
      this.setType(value);
    },
    saveAccount() {
      this.save(this.activeAccount);
    },
    ...mapActions({
      resetActive: 'account/resetActive',
      modalClose: 'modal/close',
      setName: 'account/setName',
      setType: 'account/setType',
      save: 'account/save',
    }),
  },
  computed: {
    emailServiceType() {
      if (!this.activeAccount) return false;

      return this.activeAccount.type;
    },
    ...mapGetters({
      visibleModal: 'modal/default',
      activeAccount: 'account/active',
    }),
  },
};
</script>



// WEBPACK FOOTER //
// EditAccount.vue?4277541e